module.exports = __webpack_public_path__ + "img/characters.f22dae0e.png";